import { initialMessageState, IMessageState } from '../state/message.state';
import { MessageActions, EMessageActions } from '../actions/message.actions';

export const messageReducers = (
    state = initialMessageState,
    action: MessageActions
): IMessageState => {
    switch (action.type) {
        case EMessageActions.GetMessage: {
            return {
                ...state,
                message: action.payload
            };
        }
        default:
            return state;
    }
};
